import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import config from '@/pathConfig';
import { queryTravel, reimburseExamine, queryAuditRecord, queryAdoptRecord, reimbursePrint } from '@/api/reimburse/reimburseApi.js';
export default {
  data: function data() {
    return {
      config: config,
      colorItem: {
        0: 'green',
        1: 'red',
        2: 'blue',
        3: 'gray'
      },
      flowList: [],
      loading: false,
      options: [],
      // 级联选择数据
      userInfo: this.$hdk.userInfo.get(),
      cardTitle: '审核差旅费用报销单',
      labelCol: {
        span: 8
      },
      wrapperCol: {
        span: 16
      },
      otherFees: [{
        id: 1,
        name: '招待费'
      }, {
        id: 2,
        name: '场地费'
      }, {
        id: 3,
        name: '食宿费'
      }, {
        id: 4,
        name: '保险费'
      }, {
        id: 5,
        name: '其他费用'
      }],
      formObject: {
        detail: {}
      },
      auditFormObj: {
        fillId: this.$route.query.fillId,
        auditStatus: 0,
        // 0 通过 1 不通过 3已驳回
        allow: '',
        // 是否创建节点 0是 1否
        auditOpinion: '',
        // 审核意见
        sign: '',
        // 签字信息
        node: undefined,
        // 驳回的节点id(反馈审核记录id)
        appendName: '' // 驳回的时候传
      },
      rules: {
        auditOpinion: [{
          required: false,
          message: '请输入审核意见'
        }, {
          max: 200,
          message: '字数超出限制200'
        }],
        node: [{
          required: false,
          message: '请选择驳回节点'
        }]
      },
      nodeList: [],
      sliderbar: false,
      printSrc: '',
      loadingPrint: false
    };
  },
  created: function created() {
    var _this = this;
    var $route = this.$route;
    if ($route.query.type == 1 || $route.query.type == 3) {
      this.cardTitle = '查看差旅费用报销单';
    } else if ($route.query.type == 2) {
      this.cardTitle = '审核差旅费用报销单';
      this.sliderbar = true;
    }

    // 查询费用详情
    if ($route.query.fillId) {
      queryTravel($route.query.fillId).then(function (res) {
        _this.formObject = res.data;
      });
      // 查询审核记录
      queryAuditRecord($route.query.fillId).then(function (res) {
        _this.flowList = res.data.data;
      });
    }
  },
  methods: {
    /**
     * 审核提交
     */
    onSubmit: function onSubmit() {
      var _this2 = this;
      var $confirm = this.$confirm,
        $set = this.$set,
        $refs = this.$refs,
        $message = this.$message,
        userInfo = this.userInfo,
        auditFormObj = this.auditFormObj,
        getNoticeFillDetails = this.getNoticeFillDetails,
        goBack = this.goBack;
      $refs.auditForm.validate(function (valid) {
        if (valid) {
          $confirm('确认提交吗?', '提示', {
            type: 'info',
            confirmButtonText: '确认',
            cancelButtonText: '取消'
          }).then(function () {
            $set(auditFormObj, 'sign', userInfo.signImgUrl);
            _this2.loading = true;
            reimburseExamine(_objectSpread({}, auditFormObj)).then(function (res) {
              if (res.data.code == 200) {
                $message.success('提交成功');
                // getNoticeFillDetails();
                goBack();
              }
              _this2.loading = false;
            });
          }).catch(function () {
            _this2.loading = false;
          });
        }
      });
    },
    /**
     * 驳回节点选择复制
     */
    auditNodeSelect: function auditNodeSelect(value, option) {
      var $set = this.$set,
        auditFormObj = this.auditFormObj;
      $set(auditFormObj, 'allow', option.data.attrs.dataItem.allow);
      $set(auditFormObj, 'appendName', option.data.attrs.dataItem.appendName);
    },
    auditStatusChange: function auditStatusChange(e) {
      var _this3 = this;
      var $route = this.$route;
      if (e.target.value === 1) {
        this.rules.auditOpinion[0].required = true;
      } else if (e.target.value === 3) {
        this.rules.auditOpinion[0].required = true;
        this.rules.node[0].required = true;
        queryAdoptRecord($route.query.fillId).then(function (res) {
          _this3.nodeList = res.data.data;
        });
      } else {
        this.rules.auditOpinion[0].required = false;
      }
    },
    /**
     * 打印
     */
    getPrint: function getPrint() {
      var _this4 = this;
      var $route = this.$route,
        $message = this.$message;
      this.loadingPrint = true;
      reimbursePrint($route.query.fillId).then(function (res) {
        if (res.data.data) {
          _this4.printSrc = res.data.data;
          var frame = document.getElementById('printFrame');
          setTimeout(function () {
            frame.contentWindow.print();
            _this4.loadingPrint = false;
          }, 200);
        } else {
          $message.success('未能成功生成文件');
          _this4.loadingPrint = false;
        }
      });
    },
    /**
     * 返回列表页
     */
    goBack: function goBack() {
      var $route = this.$route;
      if ($route.query.type == 3 && $route.query.path == '') {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/list'
        });
      } else if ($route.query.type == 4 && $route.query.path == '') {
        this.$router.push({
          path: '/reimburseRepairs/reimburse/accountantWork'
        });
      } else if ($route.query.path == 'reimbursement') {
        this.$router.push({
          path: '/dashboard/reimbursement'
        });
      } else if ($route.query.path == 'homepage') {
        this.$router.push({
          path: '/dashboard/homepage'
        });
      } else if ($route.query.path == 'system') {
        this.$router.push({
          path: '/dashboard/systemnotifi'
        });
      } else if ($route.query.type == 3) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/list'
        });
      } else {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/audit'
        });
      }
    },
    onSliderbar: function onSliderbar() {
      var sliderbar = this.sliderbar;
      if (sliderbar) {
        this.sliderbar = false;
      } else {
        this.sliderbar = true;
      }
    }
  }
};